import { useEffect, useState } from 'react';

import { useTypedMediaQuery } from '@internal/hooks/use-typed-media-query';

import { APPLY_DRAWER_WIDTH } from './project-view.styled';

export const useApplyDrawerWidth = (mainColumn: HTMLElement | null): string => {
  const isWide = useTypedMediaQuery(theme => theme.breakpoints.up('lg'));
  const [measured, setMeasured] = useState<number | null>(null);

  useEffect(() => {
    if (!mainColumn || !isWide) {
      setMeasured(null);
      return undefined;
    }

    const measure = () => {
      const { right } = mainColumn.getBoundingClientRect();
      setMeasured(Math.max(0, document.documentElement.clientWidth - right));
    };

    measure();

    // The column keeps its width when the grid shifts (window resize, side nav
    // collapse), so watch its parent as well as the element itself.
    const observer = new ResizeObserver(measure);
    observer.observe(mainColumn);
    if (mainColumn.parentElement) observer.observe(mainColumn.parentElement);
    window.addEventListener('resize', measure);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [mainColumn, isWide]);

  return measured === null ? APPLY_DRAWER_WIDTH : `${measured}px`;
};
